export default "__VITE_ASSET__08bb1993__"